<template>
    <div class="root-layout" :class="fullLayoutClass">
        <slot></slot>
    </div>
</template>

<script>
    import {isArray} from '@config/utils'
    export default {
        props: {
            moduleCode: {
                type: String,
                require: true,
                default: null
            },
            subModuleCode: {
                type: String,
                default: null
            },
            layoutClass: {
                type: Array|String,
                default: ''
            },
        },
        beforeMount() {
            let route = this.$route;
            let applicationCode = route?.params?.appCode;
            let currentPath = route.path.replace(/^\/|\/$/g, '').split('/');
            let alias = currentPath.length > 1 ? currentPath[0] : null;
            this.$root.loadModuleSettings(
                this.moduleCode,
                this.subModuleCode,
                alias && this.moduleCode.toLowerCase() != alias.toLowerCase() ? alias : null,
                applicationCode
            );
            // Add/update the canonical URL on initial load
            this.updateCanonicalUrl()
        },
        mounted() {
            // Update the canonical URL after navigation
            this.$router.afterEach((to, from) => {
                this.updateCanonicalUrl()
            })
        },
        computed: {
            fullLayoutClass() {
                return this.classList([`module-${this.moduleCode}`, this.layoutClass]);
            },
        },
        methods: {
            classList(...classes) {
                return classes
                    .map(c => isArray(c) ? c : [c])
                    .reduce((classes, c) => classes.concat(c), []);
            },
            updateCanonicalUrl() {
                let link = !!document.querySelector("link[rel='canonical']") ?
                    document.querySelector("link[rel='canonical']") :
                    document.createElement('link');
                link.setAttribute('rel', 'canonical');
                link.setAttribute('href', window.location.href);
                document.head.appendChild(link);
            },
        },
    }
</script>
